import React from 'react'
import { Link } from 'react-router-dom'

const CTAComp = () => {
  return (
    <div className='cta-container'>
        <div className="cta-content">
            <div class="inner">
                <h1 class="main-title">Are you interested or <span>you want to talk to a specialist?</span></h1>
                {/* <Link to="/contact" class="main-btn">Get Quote</Link> */}
                <Link to="/contact" class="border-btn">Contact Us</Link>
            </div>
        </div>
    </div>
  )
}

export default CTAComp